module.exports = __webpack_public_path__ + "img/company-honor-VOC-20230309.9ba789cc.jpg";